import { render, staticRenderFns } from "./Vpc.vue?vue&type=template&id=c35ff712"
import script from "./Vpc.vue?vue&type=script&lang=js"
export * from "./Vpc.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports